export const INFO_SECTION_SLIDER_PROPERTIES = {
  SPEED: 1000,
  AUTOPLAY_SPEED: 2000
}